const Event = require('../../../entities/Event');
const { Age } = require('../../../Constants/Constants');
const EventNames = require('../../Names/EventNames');

class ImpactOfIndustry extends Event {
    constructor(){
        super(
            Age.Age3,
            EventNames.ImpactOfIndustry,
            "Each civilization scores culture equal to the amount of resource its mines produce. (Ignore any production from other sources)",
            {}
        )
    }
}

module.exports = ImpactOfIndustry;